import React, { useEffect } from 'react';

import BSpeedDial from './BSpeedDial';
import Avatar from '@material-ui/core/Avatar';
import AddComment from '@material-ui/icons/AddComment';


// eslint-disable-next-line
export default function (props) {

    const tempLog = (event) => {
        console.log(event);
    }

    const addActions = [
        { icon: <Avatar />, name: 'Edit Profile', onClick: tempLog },
    ]

    useEffect(() => {

        // eslint-disable-next-line
    }, []);

    return (
        <>
            <BSpeedDial
                icon={<AddComment fontSize="large"/>}
                posname='bottom-right'
                actions={addActions}
                direction={"up"}
            />
        </>
    )
}
